/* eslint-disable max-len */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const football_fields = [
  {
    title: 'AFL Arena',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(093) 432-50-70'],
    address: 'г.Киев, ул. Озёрная, 2А, Оболонский район',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/20-aug/photo_2021-08-19+22.08.37.jpeg',
      // 'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/20-aug/IMG_7060.MOV',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/20-aug/photo_2021-08-20+09.44.21.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/20-aug/photo_2021-08-20+09.44.26.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/20-aug/photo_2021-08-20+09.44.29.jpeg',
    ],
    link: '',
    lat: 50.5231777,
    lng: 30.4884495,
    features: {
      size: '40х20, 64х42, 100х64',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12, 12-16, 16-22',
      workingSchedule: '06:30-21:30',
      inventory: true,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'REJO-ВДНХ: мини-футбольный манеж №1',
    price: '900 - 1800 грн.',
    priceFrom: 900,
    priceTo: 1800,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, просп. Академика Глушкова 1, ВДНГ',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0427077001618766768.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0772684001596189297.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0545157001620121290.JPG',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0798117001596189281.JPG',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-manezh-1-rejo-vdng-v-kieve',
    lat: 50.378485,
    lng: 30.4789013,
    features: {
      size: '40х20м',
      cover: 'Искусственная трава',
      roof: 'Крытое, манеж',
      playersCapacity: '8-12 человек',
      workingSchedule: '06:30-00:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'REJO-Восход: мини-футбольное поле',
    price: '600 грн',
    priceFrom: 600,
    priceTo: 600,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, ул. Бориспольская 8',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-sk-vosxod-v-kieve-2.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-sk-vosxod-v-kieve-2',
    lat: 50.42809519999999,
    lng: 30.6662161,
    features: {
      size: '35х17м',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-10 человек',
      workingSchedule: '06:30-00:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'REJO-Полет: Площадка №1',
    price: '800 - 1700 грн.',
    priceFrom: 800,
    priceTo: 1700,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, пр. Воздухофлотский 80',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0228269001618766398.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0281386001620637449.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0366016001618766378.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-manezh-1-sk-polyot-v-kieve',
    lat: 50.41568789999999,
    lng: 30.4448187,
    features: {
      size: '40х20м',
      cover: 'Искусственная трава',
      roof: 'Крытое, манеж',
      playersCapacity: '8-12 человек',
      workingSchedule: '06:30-00:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'REJO-Полет: мини-футбольный зал',
    price: '800 - 1700 грн.',
    priceFrom: 800,
    priceTo: 1700,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, пр. Воздухофлотский 80',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0366016001618766378.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-sk-polyot-v-kieve',
    lat: 50.41568789999999,
    lng: 30.4448187,
    features: {
      size: '40x20м',
      cover: 'Искусственная трава',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12 человек',
      workingSchedule: '06:30-00:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'REJO-ВДНХ: мини-футбольный манеж №2',
    price: '900 - 1800 грн',
    priceFrom: 900,
    priceTo: 1800,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, просп. Академика Глушкова 1, ВДНГ',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/REJO-ВДНХ%3A+мини-футбольный+манеж+№2/1cbcb6b17b073f40982d82522ef977ec.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-manezh-2-rejo-vdng-v-kieve.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/REJO-ВДНХ%3A+мини-футбольный+манеж+№2/53c73d5d95a3c991179487efa822f6d6.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-manezh-2-rejo-vdng-v-kieve',
    lat: 50.378485,
    lng: 30.4789013,
    features: {
      size: '40х20м',
      cover: 'Искусственная трава',
      roof: 'Крытое, манеж',
      playersCapacity: '8-12 человек',
      workingSchedule: '06:30-00:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'REJO-Полет: мини-футбольный манеж №2',
    price: '800 - 1700 грн',
    priceFrom: 800,
    priceTo: 1700,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, пр. Воздухофлотский 80',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-manezh-2-sk-polyot-v-kieve.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/REJO-Полет%3A+мини-футбольный+манеж+№2/ae3e8563fc01090bc133ae230717cb44.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/REJO-Полет%3A+мини-футбольный+манеж+№2/b7a770e68679ba4eb3a11ed8fae0c531.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/REJO-Полет%3A+мини-футбольный+манеж+№2/f4b3dd7850670113a56f8b710255b165.png',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-manezh-2-sk-polyot-v-kieve',
    lat: 50.41568789999999,
    lng: 30.4448187,
    features: {
      size: '40х20м',
      cover: 'Искусственная трава',
      roof: 'Крытое, манеж',
      playersCapacity: '8-12 человек',
      workingSchedule: '06:30-00:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'REJO-Полет: мини-футбольный манеж №3',
    price: '800 - 1700 грн',
    priceFrom: 800,
    priceTo: 1700,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, пр. Воздухофлотский 80',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-manezh-3-sk-polyot-v-kieve.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/REJO-Полет%3A+мини-футбольный+манеж+№3/0f8f3c4de92f693f4ad8c4097ca18552.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/REJO-Полет%3A+мини-футбольный+манеж+№3/c54c720cc392d5eb83ae12eda9086669.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/REJO-Полет%3A+мини-футбольный+манеж+№3/e024c81b67c1c4f2bc4163d7d9b54a47.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-manezh-3-sk-polyot-v-kieve',
    lat: 50.4330135,
    lng: 30.6704596,
    features: {
      size: '40х20м',
      cover: 'Искусственная трава',
      roof: 'Крытое, манеж',
      playersCapacity: '8-12 человек',
      workingSchedule: '06:30-00:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'REJO-Атлет: мини-футбольный манеж',
    price: '900 - 1600 грн',
    priceFrom: 900,
    priceTo: 1600,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, ул. Зрошувальна 4а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0054325001614597018.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0768325001614597064.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/0997440001614597073.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/2020-03-02.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-manezh-sk-atlet-v-kieve',
    lat: 50.4225244,
    lng: 30.6653883,
    features: {
      size: '40х20м',
      cover: 'Искусственная трава',
      roof: 'Крытое, манеж',
      playersCapacity: '8-12 человек',
      workingSchedule: '06:30-00:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал в Киеве',
    price: '1700 грн / 1.5 часа',
    priceFrom: 1700,
    priceTo: 1700,
    phone: ['(097) 933-74-47'],
    address: 'г.Киев, пр. Победы 34 /ул. Зоологическая',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-v-kieve-prospekt-pobedi-politekh.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-v-kieve-prospekt-pobedi-politekh',
    lat: 50.454373,
    lng: 30.4607635,
    features: {
      size: '40х20м',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12 человек',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в центре Киева, рядом с метро Дворец Украина.',
    price: '1000 грн/час',
    priceFrom: 1000,
    priceTo: 1000,
    phone: ['(095) 270-41-77'],
    address: 'г.Киев, ул. Антоновича 130/17',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/31.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-centre-kieva',
    lat: 50.419965,
    lng: 30.5174442,
    features: {
      size: '40х20м',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12 человек',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в центре Киева, на Жилянской',
    price: '1000 грн/час',
    priceFrom: 1000,
    priceTo: 1000,
    phone: ['(095) 270-41-77'],
    address: 'г.Киев, ул. Жилянская 75',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-na-jilanskoi.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-na-jilanskoi',
    lat: 50.4389385,
    lng: 30.4987675,
    features: {
      size: '41х21м',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12 человек',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле на Троещине, Киев',
    price: 'от 500 грн/час',
    priceFrom: 500,
    priceTo: 500,
    phone: ['(067) 921-93-42'],
    address: 'г.Киев, ул. Закревского 32',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-na-troeshhine-kiev.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-na-troeshhine-kiev',
    lat: 50.5161714,
    lng: 30.6267012,
    features: {
      size: '40х20м',
      cover: 'Искусственный трава',
      roof: 'Открытое',
      playersCapacity: '8-12 человек',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: false,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле на Осокорках, Киевская Инженерная Гимназия.',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: [
      '(044) 220-19-66',
      '(044) 220-19-67',
      '(044) 220-19-68',
      '(044) 220-19-69',
    ],
    address: 'г.Киев, ул. Княжий затон 12а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-na-osokorkax-kievskaya-inzhenernaya-gimnaziya.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-na-osokorkax-kievskaya-inzhenernaya-gimnaziya',
    lat: 50.4026126,
    lng: 30.6191411,
    features: {
      size: '40х20м',
      cover: 'Искусственный трава',
      roof: 'Открытое',
      playersCapacity: '8-12 человек',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: true,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Футбольное поле на Осокорках в Киеве, школа №329',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(044) 569-04-53', '(044) 569-04-54'],
    address: 'г.Киев, ул. Урловская 19в',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-na-osokorkax-v-kieve-shkola-329.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-na-osokorkax-v-kieve-shkola-329',
    lat: 50.4099284,
    lng: 30.6158676,
    features: {
      size: '40х20м',
      cover: 'Искусственное покрытие',
      roof: 'Открытое',
      playersCapacity: '8-12 человек',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: true,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Футбольное поле КНЕУ в Киеве.',
    price: 'от 150 грн/час',
    priceFrom: 150,
    priceTo: 150,
    phone: ['(044) 371-62-44', '(044) 456-71-96'],
    address: 'г.Киев, пр. Победы 66а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-kneu-v-kieve.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-kneu-v-kieve',
    lat: 50.4576913,
    lng: 30.4330677,
    features: {
      size: null,
      cover: 'Натуральная трава',
      roof: 'Открытое',
      playersCapacity: '10-14 человек',
      workingSchedule: '06:00-22:00',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: false,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольное поле на Печерске в Киеве, ДЮСШ №1',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(093) 936-27-11', '(096) 578-66-33'],
    address: 'г.Киев, ул. Ивана Кудри 22а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-na-pecherske-v-kieve-dyussh-1.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-na-pecherske-v-kieve-dyussh-1',
    lat: 50.41748339999999,
    lng: 30.5389179,
    features: {
      size: '65x45',
      cover: 'Искусственный трава',
      roof: 'Открытое',
      playersCapacity: '12-16',
      workingSchedule: '06:00-22:00',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: null,
    },
  },
  {
    title: 'Футбольное поле ЦСКА в Киеве.',
    price: '1500 грн/час',
    priceFrom: 1500,
    priceTo: 1500,
    phone: ['(044) 454-42-31', '(044) 454-43-05'],
    address: 'г.Киев, пр. Воздухофлотский 6',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-cska-v-kieve.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-cska-v-kieve',
    lat: 50.4423702,
    lng: 30.4788943,
    features: {
      size: null,
      cover: 'Натуральная трава',
      roof: 'Открытое',
      playersCapacity: 'Уточняйте',
      workingSchedule: '06:00-22:00',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольное поле стадион «Оболонь-Арена» в Киеве.',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(044) 411-39-10'],
    address: 'г.Киев, ул. Северная 26',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-stadion-obolon-arena-v-kieve.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-stadion-obolon-arena-v-kieve',
    lat: 50.5270156,
    lng: 30.5097025,
    features: {
      size: null,
      cover: 'Натуральная трава',
      roof: 'Открытое',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольное поле им. Банникова в Киеве.',
    price: '1100 грн/час',
    priceFrom: 1100,
    priceTo: 1100,
    phone: ['(044) 528-55-05', '(044) 528-72-03'],
    address: 'г.Киев, пер. Лабораторный 7 б',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-im-bannikova-v-kieve.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-im-bannikova-v-kieve',
    lat: 50.42786419999999,
    lng: 30.5252742,
    features: {
      size: null,
      cover: 'Натуральная трава',
      roof: 'Открытое',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольное поле стадион «Пионер» в Киеве на Нивках.',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(044) 442-41-63', '(044) 434-31-96'],
    address: 'г.Киев, ул. Туполева 22 д',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-stadion-pioner-v-kieve-na-nivkax.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-stadion-pioner-v-kieve-na-nivkax',
    lat: 50.479327,
    lng: 30.3965117,
    features: {
      size: null,
      cover: 'Натуральная трава',
      roof: 'Открытое',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в Парке Дружбы народов X-Park',
    price: '900 грн/1.5 часа',
    priceFrom: 900,
    priceTo: 900,
    phone: ['(063) 136-25-85'],
    address: 'г.Киев, Парк Дружбы народов X-Park',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-x-park-park-druhzbi-narodov.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-x-park-park-druhzbi-narodov',
    lat: 50.49615,
    lng: 30.546016,
    features: {
      size: '40x20м',
      cover: 'Искуственное покрытие',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: '07:00-23:00',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в Киеве на Харьковском, СК Восход',
    price: 'от 300 грн/час',
    priceFrom: 300,
    priceTo: 300,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, ул. Бориспольская 8',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-v-kieve-na-xarkovskom-sk-vosxod.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-kieve-na-xarkovskom-sk-vosxod',
    lat: 50.42809519999999,
    lng: 30.6662161,
    features: {
      size: '36x18',
      cover: 'Искуственное покрытие',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: '07:00-23:00',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: true,
      parking: true,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольное поле в Киеве, школа №41',
    price: '400 грн/час',
    priceFrom: 400,
    priceTo: 400,
    phone: ['(067) 593-73-12'],
    address: 'г.Киев, пр. Победы 7 а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-v-kieve-shkola-41.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-kieve-shkola-41',
    lat: 50.4468687,
    lng: 30.4841829,
    features: {
      size: '32x15',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: null,
    },
  },
  {
    title: 'Аренда зала на ул. Зоологической в Киеве',
    price: '700 грн/час',
    priceFrom: 700,
    priceTo: 700,
    phone: ['(098) 693-80-32'],
    address: 'г.Киев, ул. Зоологическая 82-Б',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/zal-ul-zoologicheskaya-metro-politeh.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/zal-ul-zoologicheskaya-metro-politeh',
    lat: 50.4539173,
    lng: 30.4602522,
    features: {
      size: null,
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: null,
      lighting: true,
      parking: null,
      tribunes: null,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле на Дарнице в Киеве, стадион Атлет',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(044) 513-75-04', '(044) 581-60-49', '(098) 070-16-95'],
    address: 'г.Киев, ул. Оросительная 4а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-na-darnice-v-kieve-stadion-atlet.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-na-darnice-v-kieve-stadion-atlet',
    lat: 50.4330576,
    lng: 30.6704352,
    features: {
      size: '40x20',
      cover: 'Искуственное покрытие',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: null,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольный зал в Киеве, СК «Темп»',
    price: '400 грн/час',
    priceFrom: 400,
    priceTo: 400,
    phone: ['(063) 594-43-34'],
    address: 'г.Киев, ул. Генерала Витрука, 10',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-v-kieve-sk-temp.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-v-kieve-sk-temp',
    lat: 50.4610415,
    lng: 30.3831539,
    features: {
      size: null,
      cover: 'Искуственное покрытие',
      roof: 'Футзальное покрытие',
      playersCapacity: '8-12',
      workingSchedule: '10:00-23:00',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле на Оболони, Киев.',
    price: '375 грн/час',
    priceFrom: 375,
    priceTo: 375,
    phone: ['(098) 101-02-19'],
    address: 'г.Киев, ул. Мате Залки 8 г',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-na-oboloni-kiev.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-na-oboloni-kiev',
    lat: 50.4942825,
    lng: 30.5152816,
    features: {
      size: '50x30',
      cover: 'Искусственный трава',
      roof: 'Открытое',
      playersCapacity: '8-14',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольное поле, Центр отдыха в Козине',
    price: 'до 250 грн/час',
    priceFrom: 250,
    priceTo: 250,
    phone: ['(097) 851-75-36', '(093) 700-58-34', '(044) 251-68-71'],
    address: 'г.Киев, ул. Соловьяненко 308',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-centr-otdyxa-v-kozine.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-centr-otdyxa-v-kozine',
    lat: 50.2009088,
    lng: 30.68352939999999,
    features: {
      size: '40x20',
      cover: 'Искусственный трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в Сырецком парке',
    price: '350 грн/час',
    priceFrom: 350,
    priceTo: 350,
    phone: ['(093) 644-44-62'],
    address: 'г.Киев, ул. Тимофея Шамрыло 2',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-v-syreckom-parke.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-syreckom-parke',
    lat: 50.4688509,
    lng: 30.4420435,
    features: {
      size: '40x20',
      cover: 'Искусственный трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольное поле в Киеве СК «Проспект-Спорт» на Дарнице',
    price: '250 - 500 грн/час',
    priceFrom: 250,
    priceTo: 500,
    phone: ['(098) 397-32-17'],
    address: 'г.Киев, пер. Магнитогорский 1',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-v-kieve-na-darnice-2.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-kieve-na-darnice-2',
    lat: 50.4545758,
    lng: 30.64180319999999,
    features: {
      size: '40х20',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал на Печерске в Киеве',
    price: 'от 950 грн/час',
    priceFrom: 950,
    priceTo: 950,
    phone: ['(067) 108-19-38', '(067) 400-17-60', '(044) 503-55-03'],
    address: 'г.Киев, ул. Драгомирова 9а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-na-pecherske.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-na-pecherske',
    lat: 50.4101218,
    lng: 30.5465873,
    features: {
      size: '40х20',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, минифутбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поля на м. Харьковская, Киев',
    price: 'от 200 грн/час',
    priceFrom: 200,
    priceTo: 200,
    phone: ['(066) 599-98-34'],
    address: 'г.Киев, ул. Вербицкого (Парк Воинов-интернационалистов)',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-polya-na-m-xarkovskaya-kiev.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-polya-na-m-xarkovskaya-kiev',
    lat: 50.40822000000001,
    lng: 30.660137,
    features: {
      size: '40х20',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, минифутбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал в Киеве, ул. Промышленная 1',
    price: '300 - 600 грн/час',
    priceFrom: 300,
    priceTo: 600,
    phone: ['(063) 108-37-00'],
    address: 'г.Киев, ул. Промышленная, 1',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-v-kieve-ul-promishlennaya-1.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-v-kieve-ul-promishlennaya-1',
    lat: 50.3983727,
    lng: 30.5650948,
    features: {
      size: '25x12',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '6-10',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Аренда поля для футбола возле метро Голосеевская',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(068) 116-60-31'],
    address: 'г.Киев, ул. Стельмаха 9',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/pole-dlya-futbola-metro-goloseevskaya.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/pole-dlya-futbola-metro-goloseevskaya',
    lat: 50.3945707,
    lng: 30.5021522,
    features: {
      size: '40x20',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал на Подоле',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(044) 393-43-43'],
    address: 'г.Киев, ул. Ярославская 56а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-na-podole.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-na-podole',
    lat: 50.471407,
    lng: 30.5175096,
    features: {
      size: '17x12',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '6-8',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал университета МНТУ',
    price: '350 грн/час',
    priceFrom: 350,
    priceTo: 350,
    phone: ['(093) 545-33-05'],
    address: 'г.Киев, пер. Магнитогорский 3',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-na-metro-chernigovskaya.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-na-metro-chernigovskaya',
    lat: 50.45310440000001,
    lng: 30.6371356,
    features: {
      size: '27x13',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольное поле Житомирская трасса, Спорт База «Антей»',
    price: '600 грн',
    priceFrom: 600,
    priceTo: 600,
    phone: ['(067) 209-61-92'],
    address: 'г.Киев, Житомирская трасса, КПП',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-sport-baza-antei.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-sport-baza-antei',
    lat: 50.4562451,
    lng: 30.3654504,
    features: {
      size: '42х22м',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-14',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в центре Киева, на Олимпийской, СШ №78',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(044) 248-77-72', '(044) 248-76-66'],
    address: 'г.Киев, ул. Шота Руставели 47',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-ssh-78.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-ssh-78',
    lat: 50.4351723,
    lng: 30.5191657,
    features: {
      size: '37х17м',
      cover: 'Искуственное покрытие',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: '08:00-22:00',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: null,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольный зал спорткомплекса НАУ',
    price: '200 грн/час',
    priceFrom: 200,
    priceTo: 200,
    phone: ['(044) 406-77-34', '(044) 406-77-61', '(044) 497-01-13'],
    address: 'г.Киев, пр. Космонавта Комарова 1',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-sportkompleksa-nau.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-sportkompleksa-nau',
    lat: 50.4399503,
    lng: 30.4282238,
    features: {
      size: '35х18м',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: null,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Сквош на Троещине',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(044) 364-46-46'],
    address: 'г.Киев, пр. Маяковского, 46',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-na-troeshhine-v-sportlife.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-na-troeshhine-v-sportlife',
    lat: 50.5165357,
    lng: 30.6186156,
    features: {
      size: '35х18м',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: null,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольное поле на стадионе «Меридиан» в Киеве',
    price: '400-700 грн/час',
    priceFrom: 400,
    priceTo: 700,
    phone: ['(097) 760-30-30'],
    address: 'г.Киев, ул. Героев Севастополя 11в',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-na-stadione-meridian-v-kieve-2.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-na-stadione-meridian-v-kieve-2',
    lat: 50.4413423,
    lng: 30.4195793,
    features: {
      size: '40х22м',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: false,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле на ул. Северо-Сырецкой',
    price: '700 - 1000 грн/час',
    priceFrom: 700,
    priceTo: 1000,
    phone: ['(063) 233-13-39', '(096) 754-18-60', '(063) 285-14-84'],
    address: 'г.Киев, ул. Северо-Сырецкая, 3',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-severo-siretskaya.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-severo-siretskaya',
    lat: 50.4888486,
    lng: 30.4222561,
    features: {
      size: '40х22м',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: false,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал на «Ледовом стадионе»',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(044) 526-60-66', '(044) 526-52-26', '(044) 526-33-33'],
    address: 'г.Киев, пр. Академика Глушкова 9',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnye-polya-na-ledovom-stadione.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnye-polya-na-ledovom-stadione',
    lat: 50.37292249999999,
    lng: 30.4676478,
    features: {
      size: null,
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: null,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольное поле СК «Фитнес Олимп» в Киеве на Нивках',
    price: 'от 400 грн/час',
    priceFrom: 400,
    priceTo: 400,
    phone: ['(067) 548-79-59'],
    address: 'г.Киев, ул. Кулибина 11',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-nivki-fitnes-olimp.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-nivki-fitnes-olimp',
    lat: 50.4545203,
    lng: 30.4002406,
    features: {
      size: '40x20',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольные поля спорткомплекса «Чемпион»',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(096) 260-30-30', '(098) 997-88-88'],
    address: 'г.Киев, ул. Вербицкого 23',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnye-polya-sportkompleksa-chempion.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnye-polya-sportkompleksa-chempion',
    lat: 50.4080425,
    lng: 30.657268,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в центре Киева, рядом с метро Дворец Спорта',
    price: '1000 грн/час',
    priceFrom: 1000,
    priceTo: 1000,
    phone: ['(067) 536-37-20'],
    address: 'г.Киев, площа Спортивна 1',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-v-centre-kieva-ryadom-s-metro-dvorec-sporta-2.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-centre-kieva-ryadom-s-metro-dvorec-sporta-2',
    lat: 50.4371865,
    lng: 30.5223532,
    features: {
      size: '28x15',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '6-10',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле СШ №158',
    price: '200 грн/1,5 часа',
    priceFrom: 200,
    priceTo: 200,
    phone: ['(097) 338-83-38', '(044) 540-91-01', '(044) 540-91-37'],
    address: 'г.Киев, ул. Стальского 12',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-ssh-158.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-ssh-158',
    lat: 50.48360419999999,
    lng: 30.5990168,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '6-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: null,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Аренда поля для мини-футбола на Святошино',
    price: '300 грн/час',
    priceFrom: 300,
    priceTo: 300,
    phone: ['+38'],
    address: 'г.Киев, вул. Академіка Доброхотова 7А',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/arenda-polya-dlya-mini-futbola-na-svyatoshino-2.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/arenda-polya-dlya-mini-futbola-na-svyatoshino-2',
    lat: 50.4612562,
    lng: 30.3659468,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '6-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в парке Дружбы Народов, Киев',
    price: 'от 400 грн/час',
    priceFrom: 400,
    priceTo: 400,
    phone: ['(099) 541-07-30'],
    address: 'г.Киев, Парк Дружбы народов X-Park',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-manej-v-parke-drujbi-narodov.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-manej-v-parke-drujbi-narodov',
    lat: 50.49615,
    lng: 30.546016,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '6-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Аренда мини-футбольное поле в Гидропарке «Город Спорта» в Киеве',
    price: '400 - 1000 грн/час',
    priceFrom: 400,
    priceTo: 1000,
    phone: ['(067) 440-03-34'],
    address: 'г.Киев, Гидропарк (Киев)',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-v-gidroparke-gorod-sporta.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-gidroparke-gorod-sporta',
    lat: 50.4440605,
    lng: 30.5760127,
    features: {
      size: '42x28',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '10-16',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал ФСО «Динамо»',
    price: '500 грн/час',
    priceFrom: 500,
    priceTo: 500,
    phone: [
      '(067) 220-39-06',
      '(044) 254-72-73',
      '(044) 254-72-73',
      '(044) 256-11-21',
    ],
    address: 'г.Киев, ул. Орлика 15',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-fso-dinamo.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-fso-dinamo',
    lat: 50.4409976,
    lng: 30.5370099,
    features: {
      size: '35x15',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал Спорткомплекс ДБК-4',
    price: '300 грн/час',
    priceFrom: 300,
    priceTo: 300,
    phone: ['(044) 430-94-75', '(066) 615-17-05'],
    address: 'г.Киев, ул. Луговая 13',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-sportkompleks-dbk-4.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-sportkompleks-dbk-4',
    lat: 50.509116,
    lng: 30.4695832,
    features: {
      size: '35x15',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле на Подоле',
    price: '500 - 700 грн/час',
    priceFrom: 500,
    priceTo: 700,
    phone: ['(050) 130-66-02'],
    address: 'г.Киев, ул. Набережно-Луговая 8',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-na-podole.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-na-podole',
    lat: 50.477388,
    lng: 30.506322,
    features: {
      size: '33x21',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Аренда мини-футбольное поля на Академе, в Киеве',
    price: 'от 350 грн/час',
    priceFrom: 350,
    priceTo: 350,
    phone: ['(067) 449-44-80'],
    address: 'г.Киев, ул. Академика Булаховского 4',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-na-akademe.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-na-akademe',
    lat: 50.47139989999999,
    lng: 30.35418,
    features: {
      size: '30x15',
      cover: 'Искусственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в парке «Партизанской славы» в Киеве',
    price: '300 грн/час',
    priceFrom: 300,
    priceTo: 300,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, ул. Тростянецкая 60',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-v-parke-partizanskoj-slavy.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-parke-partizanskoj-slavy',
    lat: 50.4225244,
    lng: 30.6653883,
    features: {
      size: '40x20',
      cover: 'Искусственный трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: true,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольные поля ДЮСШ №15',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(044) 250-10-33', '(044) 250-15-97'],
    address: 'г.Киев, ул. Якубовского 7а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/100x60%20s%20tribunkoy.JPG',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/2017-10-12.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-uploads/2021-06-20.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnye-polya-sportivnoj-shkoly-15',
    lat: 50.3811626,
    lng: 30.4511218,
    features: {
      size: '100х60 м., 60х40 м., 36х18 м. и 24х12 м.',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '20-22, 14-16, 8-12, 8-10',
      workingSchedule: '07:00-22:00',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал на Дорогожичах в Киеве',
    price: '650 - 750 грн/час',
    priceFrom: 650,
    priceTo: 750,
    phone: ['(095) 700-21-20'],
    address: 'г.Киев, ул. Дорогожицкая, 1',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-na-dorogozhichax-v-kieve-2.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-na-dorogozhichax-v-kieve-2',
    lat: 50.4698705,
    lng: 30.4621023,
    features: {
      size: '40x20',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле им. Банникова',
    price: '700 грн/час',
    priceFrom: 700,
    priceTo: 700,
    phone: ['(044) 528-55-05', '(044) 528-72-03'],
    address: 'г.Киев, пер. Лабораторный 7 б',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-im-bannikova.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-im-bannikova',
    lat: 50.42786419999999,
    lng: 30.5252742,
    features: {
      size: '40x30',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле СК «Динамо»',
    price: '150 грн/час',
    priceFrom: 150,
    priceTo: 150,
    phone: ['(067) 181-14-17'],
    address: 'г.Киев, Труханов остров, ул. Парковая дорога 6',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-sk-dinamo.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-sk-dinamo',
    lat: 50.444129,
    lng: 30.5486979,
    features: {
      size: '35x15',
      cover: 'Искуственное покрытие',
      roof: 'Открытое',
      playersCapacity: '8-10',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле на территории «Евробазар»',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(096) 203-88-06', '(063) 531-94-12'],
    address: 'г.Киев, Днепровская наб. 18',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-na-territorii-evrobazar.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-na-territorii-evrobazar',
    lat: 50.3987456,
    lng: 30.61266849999999,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: null,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольный зал на Позняках',
    price: '800 грн/1.5 часа',
    priceFrom: 800,
    priceTo: 800,
    phone: ['(093) 000-10-39'],
    address: 'г.Киев, пр. Григоренко 21Б',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-2.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-2',
    lat: 50.4062084,
    lng: 30.6332557,
    features: {
      size: '30x18',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-10',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: null,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольное поле «Локомотив»',
    price: '550 грн/час',
    priceFrom: 550,
    priceTo: 500,
    phone: ['(044) 465-32-75'],
    address: 'г.Киев, ул. Стадионная, 10/2',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-5.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-5',
    lat: 50.4383572,
    lng: 30.4803106,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title:
      'Аренда мини-футбольные поля в парке Дружбы Народов (Московский мост)',
    price: '600 грн/час',
    priceFrom: 600,
    priceTo: 600,
    phone: ['(096) 203-88-06'],
    address: 'г.Киев, Парк Дружбы Народов (Московский мост)',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnoe-pole-v-parke-druzbi-narodov.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnoe-pole-v-parke-druzbi-narodov',
    lat: 50.49478200000001,
    lng: 30.5463139,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал «Спортлайф»',
    price: 'от 265 грн/час',
    priceFrom: 265,
    priceTo: 265,
    phone: ['(044) 390-42-22', '(050) 411-41-12'],
    address: 'г.Киев, пр. Московский 20-б',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-sportlajf.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-sportlajf',
    lat: 50.488111,
    lng: 30.507008,
    features: {
      size: '27x15',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-10',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольные поля КПИ',
    price: '500 грн/час',
    priceFrom: 500,
    priceTo: 500,
    phone: ['(044) 456-33-43', '(066) 155-29-49'],
    address: 'г.Киев, ул. Янгеля 7а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnye-polya-kpi.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnye-polya-kpi',
    lat: 50.4489744,
    lng: 30.453333,
    features: {
      size: '35x15',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал Спорткомплекса «Сырец»',
    price: '400 грн/час',
    priceFrom: 400,
    priceTo: 400,
    phone: ['(044) 453-76-66', '(044) 440-46-11'],
    address: 'г.Киев, ул. Котовского 4',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-sportkompleka-syrec.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-sportkompleka-syrec',
    lat: 50.47876609999999,
    lng: 30.4416118,
    features: {
      size: '40x20',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал Спорткомплекс КПИ',
    price: '440 грн/час',
    priceFrom: 440,
    priceTo: 440,
    phone: ['(044) 456-33-43', '(066) 155-29-49'],
    address: 'г.Киев, ул. Верхнеключевая 1/26',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-sportkompleks-kpi.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-sportkompleks-kpi',
    lat: 50.4427224,
    lng: 30.4470189,
    features: {
      size: '35x15',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал СК «Универсал»',
    price: '350 грн/час',
    priceFrom: 350,
    priceTo: 350,
    phone: ['(093) 487-77-18', '(050) 510-33-33'],
    address: 'г.Киев, пр. Алишера Навои 1',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal',
    lat: 50.4727979,
    lng: 30.6051612,
    features: {
      size: '31x19',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-10',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: null,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле на Дворце Украина',
    price: '1000 грн/час',
    priceFrom: 1000,
    priceTo: 1000,
    phone: ['(050) 708-87-78'],
    address: 'г.Киев, ул. Лыбидская 17',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-3.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-3',
    lat: 50.4369699,
    lng: 30.4989688,
    features: {
      size: '50x25',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-14',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: null,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле СК газеты «Киевская Правда»',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(063) 870-56-38', '(066) 730-32-12'],
    address: 'г.Киев, ул. Маршала Гречко 13',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole',
    lat: 50.49095,
    lng: 30.4076515,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: null,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле в Голосеевском',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(097) 646-83-02'],
    address: 'г.Киев, ул. Лысогорская 4',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnoe-pole-2.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-2',
    lat: 50.3901287,
    lng: 30.5308571,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: null,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле СШ №98',
    price: '200 грн/1,5 часа',
    priceFrom: 200,
    priceTo: 200,
    phone: ['(097) 338-83-38'],
    address: 'г.Киев, ул. Ивана Микитенко 7б',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/ssh-98.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/ssh-98',
    lat: 50.4871275,
    lng: 30.5962425,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: null,
      wardrobe: null,
      lighting: null,
      parking: null,
      tribunes: null,
      toilet: null,
    },
  },
  {
    title: 'Мини-футбольный зал Спорткомплекс ДСК-3',
    price: '200 - 400 грн/час',
    priceFrom: 200,
    priceTo: 400,
    phone: ['(067) 654-17-71'],
    address: 'г.Киев, ул. Бакунина 1',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/mini-futbolnyj-zal-sportkompleks-dsk-3.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnyj-zal-sportkompleks-dsk-3',
    lat: 50.4161528,
    lng: 30.430142,
    features: {
      size: '40x20',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: null,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал СК «Авангард»',
    price: '500 грн/час',
    priceFrom: 500,
    priceTo: 500,
    phone: ['(067) 231-57-26', '(067) 233-69-29'],
    address: 'г.Киев, ул. Мельникова 46',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/sk-avangard.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/sk-avangard',
    lat: 50.4733542,
    lng: 30.4560475,
    features: {
      size: '35x17',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Футбольная арена МАУП в Киеве',
    price: '800 грн/час',
    priceFrom: 800,
    priceTo: 800,
    phone: ['(073) 070-71-11'],
    address: 'г.Киев, ул. Владимира Брожко, 17',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futbolnaya-arena-maup.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futbolnaya-arena-maup',
    lat: 50.4121187,
    lng: 30.5123374,
    features: {
      size: '40x20, 60x40',
      cover: 'Искуственная трава',
      roof: 'Открытое',
      playersCapacity: '8-12, 12-16',
      workingSchedule: '07:00-23:00',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал СК НПУ Драгоманова',
    price: '800 грн/час',
    priceFrom: 800,
    priceTo: 800,
    phone: ['(044) 482-18-44', '(044) 486-37-70', '(044) 486-36-28'],
    address: 'г.Киев, ул. Тургеневская 3-9',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/sk-npu-dragomanova.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/sk-npu-dragomanova',
    lat: 50.4483196,
    lng: 30.4946398,
    features: {
      size: '35x15',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал на Лесной, в Киеве',
    price: 'от 700 грн/час',
    priceFrom: 700,
    priceTo: 700,
    phone: ['(067) 209-80-50'],
    address: 'г.Киев, ул. Милютенка 4',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/futzal-na-lesnom.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/futzal-na-lesnom',
    lat: 50.4657356,
    lng: 30.6360598,
    features: {
      size: '40x20, 30x20',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: '07:00-23:00',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал СОЦ «Тритон»',
    price: '900 грн/1.5 часа',
    priceFrom: 900,
    priceTo: 900,
    phone: ['(044) 564-91-45', '(067) 284-98-48'],
    address: 'г.Киев, ул. Драгоманова 9-А',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/oldpics/soc-triton.jpg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/soc-triton',
    lat: 50.41422110000001,
    lng: 30.6396832,
    features: {
      size: '35x15',
      cover: 'Футзальное покрытие',
      roof: 'Крытое, мини-футбольный зал',
      playersCapacity: '8-12',
      workingSchedule: '07:00-23:00',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: null,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: "Футбольний центр 'Спартак'",
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(097) 760-30-30'],
    address: 'г.Киев, вул. Кирилівська (Фрунзе), 105',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/Футбольний+центр+Спартак/spartak-image-new.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/Футбольний+центр+Спартак/spartak-img-1.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/Футбольний+центр+Спартак/spartak-img-four.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/Футбольний+центр+Спартак/spartak-img-one.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/Футбольний+центр+Спартак/spartak-new-one.jpg',
    ],
    link: 'https://mini-football.com.ua/spartak',
    lat: 50.4823399,
    lng: 30.4756294,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое летом, закрытое зимой',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольний центр “Меридіан”',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(097) 760-30-30'],
    address: 'г.Киев, вул. Героїв Севастополя, 11 В',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/%D0%A4%D1%83%D1%82%D0%B1%D0%BE%D0%BB%D1%8C%D0%BD%D0%B8%D0%B9+%D1%86%D0%B5%D0%BD%D1%82%D1%80+%D0%9C%D0%B5%D1%80%D0%B8%D0%B4%D1%96%D0%B0%D0%BD/merydian-list-photo-2.png',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/%D0%A4%D1%83%D1%82%D0%B1%D0%BE%D0%BB%D1%8C%D0%BD%D0%B8%D0%B9+%D1%86%D0%B5%D0%BD%D1%82%D1%80+%D0%9C%D0%B5%D1%80%D0%B8%D0%B4%D1%96%D0%B0%D0%BD/merydian-slide-f.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/%D0%A4%D1%83%D1%82%D0%B1%D0%BE%D0%BB%D1%8C%D0%BD%D0%B8%D0%B9+%D1%86%D0%B5%D0%BD%D1%82%D1%80+%D0%9C%D0%B5%D1%80%D0%B8%D0%B4%D1%96%D0%B0%D0%BD/merydian-slide-three.jpg.png',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/%D0%A4%D1%83%D1%82%D0%B1%D0%BE%D0%BB%D1%8C%D0%BD%D0%B8%D0%B9+%D1%86%D0%B5%D0%BD%D1%82%D1%80+%D0%9C%D0%B5%D1%80%D0%B8%D0%B4%D1%96%D0%B0%D0%BD/merydian-slide-two.jpg.png',
    ],
    link: 'https://mini-football.com.ua/merydian',
    lat: 50.443895,
    lng: 30.419467,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое летом, закрытое зимой',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольний центр “Берковщина”',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(050) 143-25-25'],
    address: 'г.Киев, вул. Дніпровська набережна, 8а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/berkov-img.jpg',
    ],
    link: 'https://mini-football.com.ua/berkovshchina',
    lat: 50.409272,
    lng: 30.599839,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое летом, закрытое зимой',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольний центр “Совки”',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(050) 143-25-25'],
    address: 'г.Киев, вул. Жмеринська, 24',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/sovki-img.jpg',
    ],
    link: 'https://mini-football.com.ua/sovki',
    lat: 50.442351,
    lng: 30.373522,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое летом, закрытое зимой',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольний центр “Супутник”',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(050) 143-25-25'],
    address: 'г.Киев, бульвар Чоколівський, 42а',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/suputnyk-img.jpg',
    ],
    link: 'https://mini-football.com.ua/suputnyk',
    lat: 50.4385775,
    lng: 30.4518181,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое летом, закрытое зимой',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Футбольное поле 5 элемент',
    price: 'от 800 грн',
    priceFrom: 800,
    priceTo: 800,
    phone: ['(044) 351-77-33'],
    address: 'г.Киев, ул. Электриков, 29А',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/sportklub-5-element-kiev-pole-584446d97c22f.jpg',
    ],
    link: 'https://5element.ua/?utm_source=funtime.kiev.ua&utm_medium=contacts_section&utm_campaign=free_promo',
    lat: 50.478092,
    lng: 30.5315113,
    features: {
      size: '37,5х19,5',
      cover: 'Искуственная трава',
      roof: 'Открытое летом, закрытое зимой',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'ПН-ПТ 07:00-23:00; СБ-ВС 09:00-23:00',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'SKY Arena',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(096) 260-30-30'],
    address: 'г.Киев, Проспект Академіка Глушкова, 9',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SKY+Arena/3f7ecd5be0a9ae1e94a3219bec93f4c5.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SKY+Arena/6fed38bcc9fea0541d8fa7c464f12600.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SKY+Arena/8012dbab659c3b8294d0b02c44696f1c.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SKY+Arena/cd7022ffe54b1bc332e6d9783135882e.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SKY+Arena/db98be42695faf48a4ce546e17da542a.jpeg',
    ],
    link: 'https://rejo.ua/ua/4',
    lat: 50.3729225,
    lng: 30.4676478,
    features: {
      size: '45х35',
      cover: 'Искуственная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: '6:30 - 0:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: false,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Агромат Арена',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(067) 449-44-80'],
    address: 'г.Киев, вул. Академика Булаховського, 4',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/%D0%90%D0%B3%D1%80%D0%BE%D0%BC%D0%B0%D1%82+%D0%90%D1%80%D0%B5%D0%BD%D0%B0/07f260d09ca66cdb3f7775c2cdb7c199.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/%D0%90%D0%B3%D1%80%D0%BE%D0%BC%D0%B0%D1%82+%D0%90%D1%80%D0%B5%D0%BD%D0%B0/22c00f11999bded062e70a371c908037.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/%D0%90%D0%B3%D1%80%D0%BE%D0%BC%D0%B0%D1%82+%D0%90%D1%80%D0%B5%D0%BD%D0%B0/43f6ca8b0132ca85465c5458c520a6fc.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/%D0%90%D0%B3%D1%80%D0%BE%D0%BC%D0%B0%D1%82+%D0%90%D1%80%D0%B5%D0%BD%D0%B0/6ee071402cb9d5d81cb9dc07f5038d9f.jpeg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/%D0%90%D0%B3%D1%80%D0%BE%D0%BC%D0%B0%D1%82+%D0%90%D1%80%D0%B5%D0%BD%D0%B0/a04e6fe61b44004605f34d1a522687eb.jpeg',
    ],
    link: 'https://rejo.ua/ua/tovar-ploshhadka',
    lat: 50.471454,
    lng: 30.353837,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: '6:30 - 0:30',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Sport KIDEV - Майданчик 1',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(067) 500-07-17'],
    address: 'вул. Київська, 7, Чубинське, Київська обл.',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SportKIDEV-1/61840c065616ee0973e48bbba2945004.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SportKIDEV-1/c87c7a59715d764684c1457aae2f3f74.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SportKIDEV-1/cd547d3a38c04a7c2391b283c4577ca0.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SportKIDEV-1/db4e3349c2446fd13680122e7fa43638.jpg',
    ],
    link: 'https://rejo.ua/ua/pole-2',
    lat: 50.3659416,
    lng: 30.8473573,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: false,
      parking: true,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Sport KIDEV - Майданчик 2',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(067) 500-07-17'],
    address: 'вул. Київська, 7, Чубинське, Київська обл.',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SportKIDEV-1/02616c9fa759f752f51cbe62b69c2a39.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SportKIDEV-1/61840c065616ee0973e48bbba2945004.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SportKIDEV-1/c87c7a59715d764684c1457aae2f3f74.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SportKIDEV-1/cd547d3a38c04a7c2391b283c4577ca0.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/SportKIDEV-1/db4e3349c2446fd13680122e7fa43638.jpg',
    ],
    link: 'https://rejo.ua/ua/pole-2',
    lat: 50.3659416,
    lng: 30.8473573,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: false,
      parking: true,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Fitnes Olimp - Майданчик 1',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(067) 353-03-25'],
    address: 'г. Киев, ул. Кулібіна 11',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/Fitnes+Olimp+-+%D0%9C%D0%B0%D0%B9%D0%B4%D0%B0%D0%BD%D1%87%D0%B8%D0%BA+1/2f1dd0f453b30f7ad534bbcd336e8bce.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/Fitnes+Olimp+-+%D0%9C%D0%B0%D0%B9%D0%B4%D0%B0%D0%BD%D1%87%D0%B8%D0%BA+1/4d1aafbd6fe8aa0a3ceecf0540b762cc.jpg',
    ],
    link: 'https://rejo.ua/ua/tovar-ploshhadka-1',
    lat: 50.4545203,
    lng: 30.4002406,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: false,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Fitnes Olimp - Майданчик 2',
    price: 'Уточняйте',
    priceFrom: null,
    priceTo: null,
    phone: ['(067) 548-79-59'],
    address: 'г. Киев, ул. Кулібіна 11',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/Fitnes+Olimp+-+%D0%9C%D0%B0%D0%B9%D0%B4%D0%B0%D0%BD%D1%87%D0%B8%D0%BA+1/2f1dd0f453b30f7ad534bbcd336e8bce.jpg',
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/Fitnes+Olimp+-+%D0%9C%D0%B0%D0%B9%D0%B4%D0%B0%D0%BD%D1%87%D0%B8%D0%BA+1/4d1aafbd6fe8aa0a3ceecf0540b762cc.jpg',
    ],
    link: 'https://rejo.ua/ua/tovar-ploshhadka-2',
    lat: 50.4545203,
    lng: 30.4002406,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: false,
      parking: true,
      tribunes: true,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольный зал СК «Сокол»',
    price: '400 грн/1 час',
    priceFrom: 400,
    priceTo: 400,
    phone: ['(044) 486-76-03', '(044) 481-35-37', '(067) 593-73-12'],
    address: 'г. Киев, ул. Мельникова 4',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-one-upload/timthumb.php-2.jpeg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/sk-sokol',
    lat: 50.4637141,
    lng: 30.4792238,
    features: {
      size: '35х17',
      cover: 'Дерево',
      roof: 'Закрытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: false,
      wardrobe: false,
      lighting: false,
      parking: false,
      tribunes: false,
      toilet: false,
    },
  },
  {
    title: 'Мини-футбольное поле «Гудзык Арена»',
    price: '200 грн/1,5 часа',
    priceFrom: 200,
    priceTo: 200,
    phone: ['(095) 280-04-73'],
    address: 'г. Киев, ул. Харьковское шоссе 2',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-one-upload/timthumb.php.jpeg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/gudzyk-arena',
    lat: 50.440644,
    lng: 30.625933,
    features: {
      size: '40х20',
      cover: 'Искуственная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'будни — после 20-00, выходные — до 12 и после 20-00',
      inventory: false,
      shower: false,
      wardrobe: false,
      lighting: false,
      parking: false,
      tribunes: false,
      toilet: false,
    },
  },
  {
    title: 'Мини-футбольное поле «Атек»',
    price: '500 грн/час',
    priceFrom: 500,
    priceTo: 500,
    phone: ['(044) 502-18-18', '(044) 502-18-07'],
    address: 'г. Киев, ул. Чистяковская 20',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-one-upload/timthumb.php-4.jpeg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-atek',
    lat: 50.4526448,
    lng: 30.3965306,
    features: {
      size: '50х30',
      cover: 'Натуральная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: false,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле «Атек»',
    price: '500 грн/час',
    priceFrom: 500,
    priceTo: 500,
    phone: ['(044) 502-18-18', '(044) 502-18-07'],
    address: 'г. Киев, ул. Чистяковская 20',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-one-upload/timthumb.php-4.jpeg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-atek',
    lat: 50.4526448,
    lng: 30.3965306,
    features: {
      size: '50х30',
      cover: 'Натуральная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: false,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле «Атек»',
    price: '159 грн/час',
    priceFrom: 159,
    priceTo: 159,
    phone: ['(050) 412-05-63'],
    address: 'г. Киев, пр. Московский 20-б (Sport Life)',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-one-upload/timthumb.php-5.jpeg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-trc-plazma-kiev',
    lat: 50.4880172,
    lng: 30.5069527,
    features: {
      size: '42х22',
      cover: 'Искуственная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: true,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: true,
      tribunes: false,
      toilet: true,
    },
  },
  {
    title: 'Мини-футбольное поле «Атек»',
    price: '300 грн/час',
    priceFrom: 300,
    priceTo: 300,
    phone: ['(050) 581-08-15'],
    address: 'г. Киев, ул. Салютная 35',
    images: [
      'https://footbal-fields-photos.s3.eu-central-1.amazonaws.com/new-one-upload/timthumb.php-6.jpeg',
    ],
    link: 'http://www.footballarenda.com.ua/listing/mini-futbolnoe-pole-v-kieve-na-nivkax',
    lat: 50.4727664,
    lng: 30.4213579,
    features: {
      size: '40х20',
      cover: 'Искуственная трава',
      roof: 'Открытое поле',
      playersCapacity: 'Уточняйте',
      workingSchedule: 'Уточняйте',
      inventory: false,
      shower: true,
      wardrobe: true,
      lighting: true,
      parking: false,
      tribunes: false,
      toilet: true,
    },
  },
];
